import application_settings from '../applicationSettings';
import Event from './Event';

class GetAddresses extends Event {
  eventName = "oms_getAddresses";

  constructor() {
    super();
    this.add();
  }

  /**
   * @override
   *
   * Event Function for Get loyalty points
   *
   * @return void
   *
   */
  eventFunction(data) {
    let thisObj = this;
    let requestId = data.request_id ? data.request_id : "";
    let action = data.action ? data.action : "";
    let sort_property = data.sort_property ? data.sort_property : "";
    let sort_direction = data.sort_direction ? data.sort_direction : "";
    let type = data.type ? data.type : "";
      
    data.endPoint = application_settings.endPoints.getAddresses;
    data.canUsePublicAuth = false;
    data.data = {
      sort_property: sort_property,
      sort_direction: sort_direction,
      type: type,
    };

    this.sendRequest(data, function (response) {
        if (response) {
          //format response data
          let data = thisObj.formatResponseData(response);

          //fire success event
          thisObj.onSuccessEvent(data, {
            action: action,
            request_id: requestId,
          });
        }
    });

  }
}

export default GetAddresses;